import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { c, f as e } from "../../../create-component-CBAeEoQ6.js";
import { icons as f, iconFillMap as m } from "../icons/index.js";
const d = c(
  "Icon",
  e(
    ({ fillMethod: t, name: o, ...i }, n) => {
      const r = f[o];
      if (!r)
        throw new Error(`Icon "${o}" does not exist!`);
      return /* @__PURE__ */ s.jsx(
        r,
        {
          ref: n,
          fillMethod: (t || m[o]) ?? void 0,
          ...i
        }
      );
    }
  )
);
export {
  d as DynamicIcon
};
//# sourceMappingURL=index.js.map
